import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { merge } from 'lodash-es';
import { NgIf } from '@angular/common';
import { ErrorDialogData } from '../../type/dialog.type';
import { GenericDialogDirective } from '../generic-dialog.directive';

@Component({
  selector: 'portal-ui-error-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule, NgIf],
  templateUrl: './error-dialog.component.html',
  styles: [
    `
      :host {
        @apply block min-w-64;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent extends GenericDialogDirective {
  protected readonly dialog: MatDialogRef<ErrorDialogComponent, boolean> = inject(MatDialogRef<ErrorDialogComponent, boolean>);
  protected readonly config: ErrorDialogData = merge<ErrorDialogData, ErrorDialogData>(
    { title: 'Error', button: { close: { label: 'Okay' } } },
    inject(MAT_DIALOG_DATA),
  );
}
